import { SAVE_TEST } from './action';

function testReducer(state=null, action){
    switch(action.type){
        case SAVE_TEST:
        return action.payload;
    }
    return state;
}

export default testReducer;